// eslint-disable-next-line import/no-cycle
/* eslint-disable import/order */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-async-promise-executor */
/* eslint-disable prefer-promise-reject-errors */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { AddressListRes, CountryCode } from '@/api/types/payment';

dayjs.extend(utc);

export type AddressDataType =
  | {
      label: string;
      value: string;
      code?: string;
    }
  | undefined;
type ObjectDefault = {
  [key: string]: string;
};

export type Rules = { required?: boolean; message?: string };
export type KeyOption = 'country' | 'state' | 'city';
export type DefaultKeyOption = 'countryOption' | 'stateOption' | 'cityOption';
export const addressDictionary: ObjectDefault = {
  country: 'Country/Region',
  state: 'State',
  city: 'City',
};

export const defaultAddressDictionary: ObjectDefault = {
  countryOption: 'country',
  stateOption: 'state',
  cityOption: 'city',
  // countryCode: 'countryCode',
};
export const labelDictionary: ObjectDefault = {
  country: 'countryEn',
  state: 'stateEn',
  city: 'cityEn',
};
export const transformData = (
  defaultAddress: AddressDataType,
  type: string,
  list: Array<AddressListRes>,
  rules?: Array<Rules>,
  ishidden = false,
  placeholder?: '',
) => {
  const formData = {
    data: list.map((item: AddressListRes) => {
      return {
        value: item[labelDictionary[type] as keyof AddressListRes],
        label: item[labelDictionary[type] as keyof AddressListRes],
        code: item?.iso2,
      };
    }),
    label: addressDictionary[type],
    name: type,
    defaultValue: defaultAddress,
    ishidden,
    rules: rules || [{ required: true, message: 'required' }],
    placeholder,
  };
  return formData;
};

export const transformDefautlAddress = (data?: {
  key: string;
  value: string;
  code?: string;
}): AddressDataType => {
  let label = data?.value || '';
  if (data?.code === 'HK') {
    label = 'China Hong Kong';
  }
  return { value: data?.key || '', label, code: data?.code };
};

const handleBeijingTimeToLocalTime = (time: string): string => {
  let newTime = '';
  if (time) {
    //  将服务器的北京时间 提前8小时转为世界时间 结果为时间字符串：
    const UTCSting = dayjs(time)
      .subtract(8, 'hours')
      .format('YYYY/MM/DD HH:mm:ss');
    // 世界时间 变为 当前时区 时间
    newTime = dayjs.utc(UTCSting).local().format('YYYY-MM-DD HH:mm:ss');
  }

  return newTime;
};

export const beijingToLocalDate = (time: Date): Date => {
  return new Date(
    time.getTime() - 28800000 - new Date().getTimezoneOffset() * 60000,
  );
};

/**
 * 时区转换成北京时间的方法（新）
 *
 * @param date Date
 * @returns
 */
export const convertToBeijingTime = (date: Date) => {
  return new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }));
};

export { handleBeijingTimeToLocalTime };

/**
 * 判断浏览器环境
 * @return { Boolean } 是否是服务端
 */
export const isServerSide = () => {
  return typeof window === 'undefined';
};

/**
 * 将其他时间转换成北京时间
 * @param time
 */
const localDateToBeijing = (time: string): Date => {
  const zoneOffset = 8;
  const offset2 = new Date().getTimezoneOffset() * 60 * 1000;
  const nowDate2 = new Date(time).getTime();
  const currentZoneDate = new Date(
    nowDate2 + offset2 + zoneOffset * 60 * 60 * 1000,
  );
  return currentZoneDate;
};

export { localDateToBeijing };

/**
 * 活动是否过期
 * @param target 目标时间
 * @returns boolean
 */
const getOverTime = (systemTime: string, target: string): boolean => {
  const currentZoneDate = new Date(systemTime);
  const targetZoneDate = new Date(target);
  const overTime = targetZoneDate.getTime() - currentZoneDate.getTime();
  return overTime < 0;
};

export { getOverTime };

const formatDate = (milliseconds: number) => {
  const seconds = Math.floor(milliseconds / 1000);
  const d = Math.floor(seconds / (3600 * 24));
  const h = Math.floor((seconds % (3600 * 24)) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  const dDisplay = d.toString().padStart(2, '0');
  const hDisplay = h.toString().padStart(2, '0');
  const mDisplay = m.toString().padStart(2, '0');
  const sDisplay = s.toString().padStart(2, '0');
  return `${dDisplay}:${hDisplay}:${mDisplay}:${sDisplay}`;
};

/**
 * 计算倒计时
 */
const durationTime = (endTime: Date) => {
  const time = endTime.getTime() - new Date().getTime();
  return formatDate(time);
};

const over24hours = (endTime: Date) => {
  return (
    (new Date(endTime).getTime() - new Date().getTime()) / 1000 < 60 * 60 * 24
  );
};

export const overExpire = (endTime: Date) => {
  return new Date(endTime).getTime() - new Date().getTime() > 0;
};

export const getTimezoneDate = (expireTime: string) => {
  const timezoneLaebl = (new Date().getTimezoneOffset() / 60) * -1;
  const gmt = ` (GTM${timezoneLaebl > 0 ? '+' : ''}${timezoneLaebl})`;
  // 转换
  const localTime = beijingToLocalDate(new Date(expireTime));
  return {
    localTime,
    overExpireTime: !overExpire(localTime),
    over24hours: over24hours(localTime),
    endTimeLable: dayjs(localTime).format('YYYY-MM-DD HH:mm:ss') + gmt,
    durationTimeLabel: durationTime(localTime),
  };
};

export const is = {
  get PC() {
    return !/Android|iPad|iPhone/i.test(global.navigator?.userAgent);
  },
  get OsType() {
    if (this.PC) {
      return '';
    }
    const u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
      return 'android';
    }
    if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      return 'ios';
    }
    return '';
  },
  get WechatApp() {
    return /micromessenger/i.test(global.navigator?.userAgent);
  },
};

/**
 * 货币转换千分位
 * @param { Number | String } num 要转换的数字
 * @param { Number } num 保留位数
 * @return { String }
 */
export const formatMoney = (num: number | string, decimal = 2): string => {
  if (num === undefined || num === null) {
    return '';
  }
  if (+num === 0) {
    return '0';
  }
  const digit = typeof num === 'string' ? parseFloat(num) : num;
  const currencyStr = parseFloat(digit.toFixed(decimal)).toLocaleString(
    'en-US',
  );
  const numberList = currencyStr.split('.');
  let decimalStr;
  if (numberList[1]) {
    decimalStr =
      numberList[1].length < decimal ? `${numberList[1]}0` : numberList[1];
  } else {
    decimalStr = '00';
  }
  return `${numberList[0]}.${decimalStr}`;
};

/**
 * 防抖函数
 * @param { Function } Fn 调用的函数
 * @param { Number }  wait 延迟时间
 * @param { Boolean }  immediate 是否在第一次触发立即执行一次
 */
export const debounce = (
  fn: (...rest: unknown[]) => unknown,
  wait = 100,
  immediate?: boolean,
) => {
  let timer: NodeJS.Timeout;
  return (...arg: unknown[]) => {
    if (timer) {
      clearTimeout(timer);
    }

    if (!timer && immediate) {
      fn(...arg);
    }
    timer = setTimeout(() => {
      fn(...arg);
    }, wait);
  };
};
/**
 * 存储本地数据
 * @param {String} type 存储类型sessionStorage\localStorage
 * @param {String} key 存储的key
 * @param { Object } value 存储的值
 */
export const setStorage = (
  type: 'sessionStorage' | 'localStorage' = 'localStorage',
  key: string,
  value: unknown,
) => {
  try {
    if (key) {
      const formatValue = JSON.stringify(value);
      if (!isServerSide()) {
        window[type].setItem(key, formatValue);
      }
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 获取存储本地数据
 * @param {String} type 存储类型sessionStorage\localStorage
 * @param {String} key 存储的key
 * @return {any}
 */
export const getStorage = (
  type: 'sessionStorage' | 'localStorage' = 'localStorage',
  key: string,
): any => {
  try {
    if (!isServerSide()) {
      const value = window[type].getItem(key) || 'null';
      return JSON.parse(value);
    }
    return null;
  } catch (error: any) {
    return Error(error);
  }
};

/**
 * 删除存储本地数据
 * @param {String} type 存储类型sessionStorage\localStorage
 * @param {String} key 存储的key
 *
 */
export const delStorage = (
  type: 'sessionStorage' | 'localStorage' = 'localStorage',
  key: string,
) => {
  try {
    if (key) {
      if (!isServerSide()) {
        window[type].removeItem(key);
      }
    }
  } catch (error) {
    console.error(error);
  }
};

export const CurrencySymbol = {
  USD: 'US$',
  CNY: '￥',
  NZD: 'NZ$',
  AUD: 'A$',
  HKD: 'HK$',
  EUR: '€',
  GBP: '£',
  CHF: '₣',
  SGD: 'S$',
  IDR: 'Rp',
  MYR: 'RM',
  CAD: 'C$',
  KRW: '₩',
  THB: '฿',
  JPY: '￥',
  OTHERS: '$',
};

export const renderCurrencyPrice = (
  currency: string,
  price: number,
  mark = '',
  prefix = '',
) => {
  return Number.isFinite(price) ? `${prefix}${currency}${mark} ${price}` : '--';
};

/**
 *
 * @param count 数量
 * @param noun 英文
 * @returns 带格式的单位
 */
export const getUnit = (count: number, noun: string) => {
  if (+count === 1) {
    return noun; // 输出 "1 apple"
  }
  return `${noun}s`; // 输出 "2 apples"
};

export const PRIMARY_FONT = 'CertificateFont';
export const SUB_FONT = 'CertificateSubFont';

type PaymentMethods =
  | 'AW_CARD'
  | 'PAYPAL'
  | 'AW_WECHAT'
  | 'AW_ALIPAY'
  | 'BankTransfer'
  | 'VENMO'
  | 'CASH_APP'
  | 'KLARNA'
  | 'UNION_PAY'
  | 'ALIPAY_HK'
  | 'IDEAL'
  | 'PAY_NOW';

type InnerType = {
  [key in CountryCode]?: [PaymentMethods[], PaymentMethods[]];
};

export type FilterKeysMapType = {
  ES: InnerType;
  CS: InnerType;
};

const ES_Europe = [
  ['BankTransfer', 'AW_WECHAT'],
  ['AW_CARD', 'IDEAL', 'KLARNA', 'AW_ALIPAY'],
] as [PaymentMethods[], PaymentMethods[]];
const CS_Europe = [
  ['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'],
  ['AW_CARD', 'IDEAL', 'KLARNA'],
] as [PaymentMethods[], PaymentMethods[]];
export const ES_Other = [
  ['AW_WECHAT', 'BankTransfer', 'AW_CARD'],
  ['AW_ALIPAY'],
];
export const CS_Other = [
  ['AW_WECHAT', 'AW_ALIPAY', 'AW_CARD'],
  ['BankTransfer', 'KLARNA'],
];
// ES
export const filterKeysMap: FilterKeysMapType = {
  ES: {
    [CountryCode.US]: [
      ['PAYPAL', 'AW_CARD', 'AW_WECHAT'],
      ['AW_ALIPAY', 'BankTransfer', 'VENMO', 'CASH_APP', 'KLARNA', 'UNION_PAY'],
    ],
    [CountryCode.HK]: [
      ['BankTransfer', 'AW_WECHAT', 'AW_CARD'],
      ['ALIPAY_HK', 'AW_ALIPAY'],
    ],
    [CountryCode.AU]: [
      ['AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'BankTransfer'],
    ],
    [CountryCode.CA]: [
      ['AW_WECHAT', 'AW_CARD', 'AW_ALIPAY'],
      ['BankTransfer', 'KLARNA'],
    ],
    [CountryCode.SG]: [
      ['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'PAY_NOW'],
    ],
    [CountryCode.NZ]: [['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'], ['AW_CARD']],
    [CountryCode.GB]: [
      ['BankTransfer', 'KLARNA'],
      ['AW_WECHAT', 'AW_ALIPAY', 'AW_CARD'],
    ],
    [CountryCode.JP]: [
      ['AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'BankTransfer'],
    ],
    [CountryCode.DE]: ES_Europe,
    [CountryCode.FR]: ES_Europe,
    [CountryCode.IT]: ES_Europe,
    [CountryCode.NL]: ES_Europe,
    [CountryCode.BE]: ES_Europe,
    [CountryCode.LU]: ES_Europe,
    [CountryCode.IE]: ES_Europe,
    [CountryCode.ES]: ES_Europe,
    [CountryCode.PT]: ES_Europe,
    [CountryCode.AT]: ES_Europe,
    [CountryCode.FI]: ES_Europe,
    [CountryCode.LT]: ES_Europe,
    [CountryCode.LV]: ES_Europe,
    [CountryCode.EE]: ES_Europe,
    [CountryCode.SK]: ES_Europe,
    [CountryCode.SI]: ES_Europe,
    [CountryCode.GR]: ES_Europe,
    [CountryCode.MT]: ES_Europe,
    [CountryCode.VA]: ES_Europe,
    [CountryCode.GI]: ES_Europe,
    [CountryCode.BA]: ES_Europe,
    [CountryCode.MK]: ES_Europe,
    [CountryCode.ME]: ES_Europe,
    [CountryCode.RS]: ES_Europe,
    [CountryCode.BG]: ES_Europe,
    [CountryCode.RO]: ES_Europe,
    [CountryCode.AL]: ES_Europe,
    [CountryCode.HR]: ES_Europe,
    [CountryCode.SM]: ES_Europe,
    [CountryCode.BY]: ES_Europe,
    [CountryCode.RU]: ES_Europe,
    [CountryCode.UA]: ES_Europe,
    [CountryCode.MD]: ES_Europe,
    [CountryCode.CH]: ES_Europe,
    [CountryCode.PL]: ES_Europe,
    [CountryCode.CZ]: ES_Europe,
    [CountryCode.HU]: ES_Europe,
    [CountryCode.LI]: ES_Europe,
    [CountryCode.MC]: ES_Europe,
    [CountryCode.SE]: ES_Europe,
    [CountryCode.NO]: ES_Europe,
    [CountryCode.IS]: ES_Europe,
    [CountryCode.DK]: ES_Europe,
    [CountryCode.FO]: ES_Europe,
    [CountryCode.AD]: ES_Europe,
  },
  CS: {
    [CountryCode.US]: [
      ['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'PAYPAL', 'VENMO', 'CASH_APP', 'KLARNA', 'UNION_PAY'],
    ],
    [CountryCode.HK]: [
      ['AW_WECHAT', 'ALIPAY_HK', 'AW_ALIPAY', 'AW_CARD'],
      ['BankTransfer'],
    ],
    [CountryCode.AU]: [
      ['AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'BankTransfer'],
    ],
    [CountryCode.CA]: [
      ['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'KLARNA'],
    ],
    [CountryCode.SG]: [
      ['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'PAY_NOW'],
    ],
    [CountryCode.NZ]: [['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'], ['AW_CARD']],
    [CountryCode.GB]: [
      ['BankTransfer', 'AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'KLARNA'],
    ],
    [CountryCode.JP]: [
      ['AW_WECHAT', 'AW_ALIPAY'],
      ['AW_CARD', 'BankTransfer'],
    ],
    // 欧洲地区
    [CountryCode.DE]: CS_Europe,
    [CountryCode.FR]: CS_Europe,
    [CountryCode.IT]: CS_Europe,
    [CountryCode.NL]: CS_Europe,
    [CountryCode.BE]: CS_Europe,
    [CountryCode.LU]: CS_Europe,
    [CountryCode.IE]: CS_Europe,
    [CountryCode.ES]: CS_Europe,
    [CountryCode.PT]: CS_Europe,
    [CountryCode.AT]: CS_Europe,
    [CountryCode.FI]: CS_Europe,
    [CountryCode.LT]: CS_Europe,
    [CountryCode.LV]: CS_Europe,
    [CountryCode.EE]: CS_Europe,
    [CountryCode.SK]: CS_Europe,
    [CountryCode.SI]: CS_Europe,
    [CountryCode.GR]: CS_Europe,
    [CountryCode.MT]: CS_Europe,
    [CountryCode.VA]: CS_Europe,
    [CountryCode.GI]: CS_Europe,
    [CountryCode.BA]: CS_Europe,
    [CountryCode.MK]: CS_Europe,
    [CountryCode.ME]: CS_Europe,
    [CountryCode.RS]: CS_Europe,
    [CountryCode.BG]: CS_Europe,
    [CountryCode.RO]: CS_Europe,
    [CountryCode.AL]: CS_Europe,
    [CountryCode.HR]: CS_Europe,
    [CountryCode.SM]: CS_Europe,
    [CountryCode.BY]: CS_Europe,
    [CountryCode.RU]: CS_Europe,
    [CountryCode.UA]: CS_Europe,
    [CountryCode.MD]: CS_Europe,
    [CountryCode.CH]: CS_Europe,
    [CountryCode.PL]: CS_Europe,
    [CountryCode.CZ]: CS_Europe,
    [CountryCode.HU]: CS_Europe,
    [CountryCode.LI]: CS_Europe,
    [CountryCode.MC]: CS_Europe,
    [CountryCode.SE]: CS_Europe,
    [CountryCode.NO]: CS_Europe,
    [CountryCode.IS]: CS_Europe,
    [CountryCode.DK]: CS_Europe,
    [CountryCode.FO]: CS_Europe,
    [CountryCode.AD]: CS_Europe,
  },
};

export const REDUCE_RATE_COUNTRIES = ['GB', 'NZ', 'SG', 'AU'];

export const EUROPE = [
  'DE',
  'FR',
  'IT',
  'NL',
  'BE',
  'LU',
  'IE',
  'ES',
  'PT',
  'AT',
  'FI',
  'LT',
  'LV',
  'EE',
  'SK',
  'SI',
  'GR',
  'MT',
  'VA',
  'GI',
  'BA',
  'MK',
  'ME',
  'RS',
  'BG',
  'RO',
  'AL',
  'HR',
  'SM',
  'BY',
  'RU',
  'UA',
  'MD',
  'CH',
  'PL',
  'CZ',
  'HU',
  'LI',
  'MC',
  'SE',
  'NO',
  'IS',
  'DK',
  'FO',
  'AD',
];
